// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-toggler[data-v-528307a1]{--tw-bg-opacity:1;align-items:center;background-color:#818cf8;background-color:rgb(129 140 248/var(--tw-bg-opacity));border-radius:.25rem;display:flex;height:36px;justify-content:center;width:36px}@media (min-width:1024px){.menu-toggler[data-v-528307a1]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
